<script>

    export default {
        computed: {
            activeUrl() {
                return this.$store.state.activeUrl;
            },
        },
        watch: {
            activeUrl(url) {
                this.loadRefline();
            },
        },


        mounted() {
            this.loadRefline();
        },

        methods: {
            loadRefline() {
                this.$el.innerHTML = '';
                window.REFLINE = null;
                const script = document.createElement('script');
                script.setAttribute("type", "REFLINE/Positions");
                script.setAttribute("data-url", "https://apply.refline.ch/167523/positions.html?company=1329113");
                const script2 = document.createElement('script');
                script2.setAttribute("src", "https://pub.refline.ch/167523/refline.js");
                this.$el.appendChild(script);
                this.$el.appendChild(script2);
            }
        },
    };
</script>
